import NotInterestedIcon from "@mui/icons-material/NotInterested";
import { Button, Paper, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import * as React from "react";
import { GoldPackEntry, GoldPackItem } from "./entry";

interface GoldPackProps {
    list: GoldPackItem[];
    classes: any;

    onAdd();

    onUpdate(item: GoldPackItem);

    onRemove(item: GoldPackItem);
}

export class GoldPacks extends React.Component<GoldPackProps> {
    render() {
        if (!this.props.list.length) {
            return <Paper elevation={0}>
                <div className="no-items-placeholder">
                    <NotInterestedIcon/>
                    <h3>No Gem Packs found</h3>
                </div>
            </Paper>;
        }

        const {classes} = this.props;

        return <Paper elevation={0}>
            <div>
                <Table className="min-table-size">
                    <TableHead>
                        <TableRow>
                            <TableCell>Package ID</TableCell>
                            <TableCell>Gem Amount</TableCell>
                            <TableCell>Slot Index</TableCell>
                            <TableCell>Google ID</TableCell>
                            <TableCell>Apple ID</TableCell>
                            <TableCell>Samsung ID</TableCell>
                            <TableCell>Huawei ID</TableCell>
                            <TableCell style={{width: 40}}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.props.list.map(item =>
                            <GoldPackEntry key={item.id} entry={item} classes={classes}
                                           onRemove={this.props.onRemove}
                                           onUpdate={this.props.onUpdate}/>)}
                    </TableBody>
                </Table>
            </div>

            <div style={{padding: 20}}>
                <Button disableElevation variant={"contained"} color={"primary"} onClick={this.props.onAdd}>
                    Add
                </Button>
            </div>
        </Paper>;
    }
}
